import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  EEntityType,
  EFooterBlockType,
  ERelationType,
  FOOTER_BLOCK_TYPE_OPTIONS,
} from '@web/dtos';
import { CheckboxComponent } from '../../../../components/data-input/form-inputs/checkbox/checkbox.component';
import { DropDownComponent } from '../../../../components/data-input/form-inputs/drop-down/drop-down.component';
import { TranslationTextInputComponent } from '../../../../components/data-input/form-inputs/translation-text-input/translation-text-input.component';
import { IFooterBlockForm } from '../../../../entities/footer-entity';
import { CmsTextProviderService } from '../../../../services/cms-text-provider.service';
import { FooterImagesBlockEditorComponent } from './images/footer-images-block-editor.component';
import { FooterLinksBlockEditorComponent } from './links/footer-links-block-editor.component';
import { FooterLogoBlockEditorComponent } from './logo/footer-logo-block-editor.component';
import { FooterPaymentsBlockEditorComponent } from './payments/footer-payments-block-editor.component';
import { FooterTextBlockEditorComponent } from './text/footer-text-block-editor.component';

@Component({
  selector: 'aw-footer-block-editor',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CheckboxComponent,
    DropDownComponent,
    TranslationTextInputComponent,
    FooterTextBlockEditorComponent,
    FooterLinksBlockEditorComponent,
    FooterLogoBlockEditorComponent,
    FooterPaymentsBlockEditorComponent,
    FooterImagesBlockEditorComponent,
  ],
  templateUrl: './footer-block-editor.component.html',
})
export class FooterBlockEditorComponent {
  readonly block = input.required<FormGroup<IFooterBlockForm>>();
  readonly index = input.required<number>();

  protected readonly cmsTextProvider = inject(CmsTextProviderService);
  protected readonly EntityType = EEntityType;
  protected readonly TextRelationType = ERelationType;
  protected readonly FooterBlockType = EFooterBlockType;
  protected readonly footerBlockTypeOptions = FOOTER_BLOCK_TYPE_OPTIONS;
}
